import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DashboardWidgetContent, DashboardWidgetLookup } from '@serengeti/serengeti-dashboard';
import { WizardMonitoringDialogComponent } from './monitoring-dialog/monitoring-dialog.component';

@DashboardWidgetLookup('WizardMonitoringAverageComponent')
@Component({
  selector: 'app-wizard-monitoring-average',
  templateUrl: './wizard-monitoring-average.component.html',
  styleUrls: ['./wizard-monitoring-average.component.scss']
})
export class WizardMonitoringAverageComponent implements OnInit, DashboardWidgetContent {

  selectedMonitoringItemsId: any;
  
  constructor(
    private dialog: MatDialog
  ) { }

  property(): boolean {
    this.dialogOpen();
    return true;
  }

  configure(setting: any): void {
  }
  
  ngOnInit() {
  }

  dialogOpen(): void {
    const configDialogRef = this.dialog.open(WizardMonitoringDialogComponent, {
      width: '500px',
      height: '625px',
      disableClose: true,
      autoFocus: true
    });

    configDialogRef.afterClosed().subscribe((returnValue: any) => {
      if (returnValue && returnValue === false) {
        this.selectedMonitoringItemsId = false;
      } else {
        this.selectedMonitoringItemsId = returnValue;
      }

      if (returnValue && returnValue.result === true) {
      }
    });  
  }

}
